/*
 * Module for the topic label modal
 */

define([
  "marionette",
  "jquery",
  "underscore",
  "backbone",
  "messaging/messenger",
  "./touchpointMapView",
  "modules/accountAdmin/privilegeEnum",
  "modules/accountAdmin/kbRoleAdmin/kbRoleModel",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  $,
  _,
  Backbone,
  Messenger,
  TouchpointMapView,
  PrivilegeEnum,
  KbRoleModel,
  KbMenuModel,
) {
  var TOUCHPOINT_ALL_ID = 0;
  var TOUCHPOINT_TABLE_NAME = "BSE_TOUCHPOINT_SOURCE";

  var TouchpointMapController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "touchpointMapModule";
      this.kbId = null;
    },
    show: function (kbRole) {
      this.kbRole = kbRole;
      if (!this.touchpoints || this.kbId !== kbRole.get("kbId")) {
        this.kbId = kbRole.get("kbId");
        // Must fetch new collection of Touchpoints, because we modify it by adding an All Touchpoint
        // and by adding allowEdit, allowView, and allowDelete flags
        this.touchpoints = Messenger.reqres.request("fetch:kb:touchpoints", this.kbId);
        this.touchpoints.onSynced(function () {
          if (this.touchpoints.length > 1) {
            this.touchpoints.each(function (touchpoint) {
              touchpoint.set("allowDelete", false);
              touchpoint.set("allowEdit", false);
              touchpoint.set("allowView", false);
            });
            var allTouchpoints = new KbMenuModel.touchpoint({
              touchPoint: $.t("admin.kbRoleAdmin.allTouchpoints"),
              touchPointId: TOUCHPOINT_ALL_ID,
              allowDelete: false,
              allowEdit: false,
              allowView: false,
            });
            this.touchpoints.add(allTouchpoints, { at: 0 });
          }
          this._continueShow();
        }, this);
      } else {
        this._continueShow();
      }
    },
    _continueShow: function () {
      this._updateTouchpointsFromRole();
      this.view = new TouchpointMapView.touchpointMapView({ collection: this.touchpoints });

      this.view.on(
        "click:touchpoint:allowDelete",
        function (touchpointId) {
          var touchpoint = this.touchpoints.get(touchpointId);
          var allowDelete = !touchpoint.get("allowDelete");
          if (touchpointId === TOUCHPOINT_ALL_ID) {
            this.touchpoints.each(function (l) {
              l.set("allowDelete", allowDelete);
            });
          } else {
            touchpoint.set("allowDelete", allowDelete);
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            // All Touchpoint will not exist if there is a single Touchpoint
            if (touchpoint) {
              touchpoint.set("allowDelete", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:touchpoint:allowEdit",
        function (touchpointId) {
          var touchpoint = this.touchpoints.get(touchpointId);
          var allowEdit = !touchpoint.get("allowEdit");
          if (touchpointId === TOUCHPOINT_ALL_ID) {
            this.touchpoints.each(function (l) {
              l.set("allowEdit", allowEdit);
            });
          } else {
            touchpoint.set("allowEdit", allowEdit);
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            // All Touchpoint will not exist if there is a single Touchpoint
            if (touchpoint) {
              touchpoint.set("allowEdit", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.view.on(
        "click:touchpoint:allowView",
        function (touchpointId) {
          var touchpoint = this.touchpoints.get(touchpointId);
          var allowView = !touchpoint.get("allowView");
          if (touchpointId === TOUCHPOINT_ALL_ID) {
            this.touchpoints.each(function (l) {
              l.set("allowView", allowView);
            });
          } else {
            touchpoint.set("allowView", allowView);
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            // All Touchpoint will not exist if there is a single Touchpoint
            if (touchpoint) {
              touchpoint.set("allowView", false);
            }
          }
          this.view.render();
        },
        this,
      );

      this.showRegion(this.view);
    },
    _createAllPrivilege: function (privId) {
      var privilege = new KbRoleModel.kbRolePrivilege({
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
      return privilege;
    },
    _createTouchpointPrivilege: function (privId, touchPointId) {
      var privilege = new KbRoleModel.kbRolePrivilege({
        foreignKey: touchPointId,
        foreignTable: TOUCHPOINT_TABLE_NAME,
        kbRoleId: this.kbRole.get("id"),
        privId: privId,
        privName: PrivilegeEnum.getPrivilegeName(privId),
      });
      return privilege;
    },
    _updateTouchpointsFromRole: function () {
      this.touchpoints.each(function (touchpoint) {
        touchpoint.set("allowDelete", false);
        touchpoint.set("allowEdit", false);
        touchpoint.set("allowView", false);
      });
      this.kbRole.privileges().each(function (privilege) {
        var touchpoint;
        switch (privilege.get("privId")) {
          case PrivilegeEnum.TouchpointDeleteAll:
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            touchpoint.deletePrivilege = privilege;
            this.touchpoints.each(function (t) {
              t.set("allowDelete", true);
            });
            break;
          case PrivilegeEnum.TouchpointEditAll:
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            touchpoint.editPrivilege = privilege;
            this.touchpoints.each(function (t) {
              t.set("allowEdit", true);
            });
            break;
          case PrivilegeEnum.TouchpointViewAll:
            touchpoint = this.touchpoints.get(TOUCHPOINT_ALL_ID);
            touchpoint.viewPrivilege = privilege;
            this.touchpoints.each(function (t) {
              t.set("allowView", true);
            });
            break;
          case PrivilegeEnum.TouchpointDeleteSpecific:
            touchpoint = this.touchpoints.get(privilege.get("foreignKey"));
            if (touchpoint) {
              touchpoint.set("allowDelete", true);
              touchpoint.deletePrivilege = privilege;
            }
            break;
          case PrivilegeEnum.TouchpointEditSpecific:
            touchpoint = this.touchpoints.get(privilege.get("foreignKey"));
            if (touchpoint) {
              touchpoint.set("allowEdit", true);
              touchpoint.editPrivilege = privilege;
            }
            break;
          case PrivilegeEnum.TouchpointViewSpecific:
            touchpoint = this.touchpoints.get(privilege.get("foreignKey"));
            if (touchpoint) {
              touchpoint.set("allowView", true);
              touchpoint.viewPrivilege = privilege;
            }
            break;
        }
      }, this);
    },
    getPrivileges: function () {
      var newPrivileges = [];
      this.touchpoints.each(function (touchpoint) {
        var privilege;
        var touchpointId = touchpoint.get("touchPointId");
        if (touchpointId == TOUCHPOINT_ALL_ID) {
          if (touchpoint.get("allowDelete")) {
            privilege = touchpoint.deletePrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.TouchpointDeleteAll);
              touchpoint.deletePrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (touchpoint.get("allowEdit")) {
            privilege = touchpoint.editPrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.TouchpointEditAll);
              touchpoint.editPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (touchpoint.get("allowView")) {
            privilege = touchpoint.viewPrivilege;
            if (!privilege) {
              privilege = this._createAllPrivilege(PrivilegeEnum.TouchpointViewAll);
              touchpoint.viewPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
        } else {
          if (touchpoint.get("allowDelete")) {
            privilege = touchpoint.deletePrivilege;
            if (!privilege) {
              privilege = this._createTouchpointPrivilege(
                PrivilegeEnum.TouchpointDeleteSpecific,
                touchpointId,
              );
              touchpoint.deletePrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (touchpoint.get("allowEdit")) {
            privilege = touchpoint.editPrivilege;
            if (!privilege) {
              privilege = this._createTouchpointPrivilege(
                PrivilegeEnum.TouchpointEditSpecific,
                touchpointId,
              );
              touchpoint.editPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
          if (touchpoint.get("allowView")) {
            privilege = touchpoint.viewPrivilege;
            if (!privilege) {
              privilege = this._createTouchpointPrivilege(
                PrivilegeEnum.TouchpointViewSpecific,
                touchpointId,
              );
              touchpoint.viewPrivilege = privilege;
            }
            newPrivileges.push(privilege);
          }
        }
      }, this);
      return newPrivileges;
    },
  });

  return TouchpointMapController;
});
